module.exports = require('./helpers/bundle-url').getBundleURL('6Q9KC') + "logo-dark.eefe0b7f.svg";